import Client from '../axiosClient'
const resource = '/package';
const resourceInit = '/package_initialize';
const resourceFilterInit = '';
const resourceCompareInit = '/customer/compare/initialize'
const resourcePrice = '/price';
const status = '/packageStatus';
const starUrl = '/star-package';
const syncPackagesToES = '/customer/tour_list/sync_packages_to_es';
const syncPackagesPriceVariantsToES = '/customer/tour_list/sync_packages_prices_data_to_es';
const clonePackage = '/clone-package';
const SuggestionInclusionExclusion = '/suggested-inc-exc';
export default {

  init(partnerId ='',tab=0,group=[]) {
    let filterParam = 'requestFrom=addPackage&tabIndex='+tab;
    if(partnerId !=undefined && partnerId !=""){
      filterParam = filterParam+'&partnerId='+partnerId;
    }
    if(group.length>0){
      filterParam = filterParam+'&group='+group.join(",");
    }
    return Client.get(`${resourceInit}?${filterParam}`);
  },

  initFilter(arList=[]) {
    let filterParam = 'filters={"type":"filters_screen"}';
    if(arList.partnerId !=undefined && arList.partnerId !=""){
      filterParam = filterParam+'&partnerId='+arList.partnerId;
    }
    if(arList.dashRoleIdState !=undefined && arList.dashRoleIdState !=""){
      filterParam = filterParam+'&dashRoleIdState='+arList.dashRoleIdState;
    }
    if(arList.inquiryId){
      filterParam = filterParam+'&inquiryId='+arList.inquiryId;
    }
    return Client.get(`${resourceInit}?${filterParam}`);
  },

  get(payload) {
    if(payload) {
      return Client.get(`${resource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}`);
    }
    return Client.get(`${resource}`);
  },

  getDataWithFilter(payload) {
    return Client.post(`filter${resource}`, payload);
  },
  getStaredData(payload){
    return Client.post(`filter${starUrl}`, payload);
  },

  getById(id,qString="") {
    return Client.get(`${resource}/${id}`+qString);
  },

  post(payload) {
    return Client.post(`${resource}`, payload);
  },

  //Compare packages
  initCompare() {
    return Client.get(`${resourceCompareInit}`);
  },

  markStatus(payload) {
    return Client.post(`${status}`, payload);
  },

  getPackagePriceById(id,aQString="") {
    return Client.get(`${resourcePrice}?filters={"type":"formatted","packageId":"${id}"}`+aQString);
  },
  postPrice(payload) {
    return Client.post(`${resourcePrice}`, payload);
  },
  syncPackages(payload) {
    return Client.post(`${syncPackagesToES}`,payload);
  },
  syncPackagePrices(payload) {
    return Client.post(`${syncPackagesPriceVariantsToES}`, payload);
  },
  makeClone(payload){
    return Client.post(`${clonePackage}`, payload);
  },
  suggestedInclusionExclusion(payload){
    return Client.post(`${SuggestionInclusionExclusion}`, payload);
  },

  postAll(url,payload) {
    return Client.post(`${url}`, payload);
  },
  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/travel/packageRepository.js